import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackEditWishListParameters extends TrackEventBaseParameters<"item_list_id"> {}

const trackEditWishList = (parameters: TrackEditWishListParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "edit_wishlist", ...parameters }, options);
};

export default trackEditWishList;
